import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import StockoutreqFilterCriteria from './StockoutreqFilterCriteria'
import StockoutreqList from './StockoutreqList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './StockoutreqAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setStockoutreqDashboardStockoutreqList } from '../../store/slice/ManufSlice';

export default function StockoutreqListView({setShowEdit,setStockoutreqId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.stockoutreqDashboard);   

    const [filteredStockoutreqList, setFilteredStockoutreqList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { stockoutreqDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (stockoutreqDashboard.stockoutreqList.length>-1){
        setFilteredStockoutreqList(stockoutreqDashboard.stockoutreqList);
        transformToCardFormat(stockoutreqDashboard.stockoutreqList, setCardList);
      }
    },[stockoutreqDashboard.stockoutreqList])

    useEffect(()=>{
          transformToCardFormat(filteredStockoutreqList, setCardList);
      },[filteredStockoutreqList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.initiatedby==='' ){
            setFilteredStockoutreqList(stockoutreqDashboard.stockoutreqList);
            transformToCardFormat(stockoutreqDashboard.stockoutreqList, setCardList);

        } else {
            setFilteredStockoutreqList(
                stockoutreqDashboard.stockoutreqList
                    .filter(stockoutreq=> stockoutreq.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(stockoutreqDashboard.filteredStockoutreqList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <StockoutreqList
                    setShowEdit={setShowEdit}
                    setStockoutreqId = {setStockoutreqId}
                    tableList={filteredStockoutreqList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}